import type { ChangeEventHandler, FC } from 'react'
import React from 'react'

import classnames from 'classnames'

import { capitalize } from '../../utilities/misc/capitalize'
import { TypographyV2 } from '../Seatbelt2/Foundations/Typography'
import { ColourSwatch } from './ColourSwatch'
import styles from './ColourSwatchGroup.module.scss'

export const ColourSwatchGroup: FC<ColourSwatchGroupProps> = ({
  variants,
  selectedVariant,
  onChange,
  name,
  classNameRadioGroup,
}) => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const selectedVariant = e.currentTarget.value.split(',') as ProductColour[]

    onChange(selectedVariant)
  }

  const formatVariantLabel = (variant: ProductColour[]) =>
    variant.map((colour) => capitalize(colour).replace(/_/g, ' ')).join(' / ')

  const colourLabel = formatVariantLabel(selectedVariant)

  return (
    <>
      <TypographyV2
        textStyle="sb-text-body-small-regular"
        className={styles.variantColourLabel}
      >
        Colour:
        <TypographyV2
          data-testid="selected-variant-label"
          tag="span"
          textStyle="sb-text-body-small-regular"
          className={styles.selectedColour}
        >
          {colourLabel}
        </TypographyV2>
      </TypographyV2>
      <div
        data-testid="radiogroup-colour-swatch"
        role="radiogroup"
        className={classnames(styles.radiogroup, classNameRadioGroup)}
      >
        {variants.map((variant) => (
          <ColourSwatch
            name={name}
            key={variant.join()}
            value={variant}
            checked={selectedVariant.join() === variant.join()}
            onChange={handleChange}
          />
        ))}
      </div>
    </>
  )
}

export interface ColourSwatchGroupProps {
  classNameRadioGroup?: string
  variants: ProductColour[][]
  selectedVariant: ProductColour[]
  onChange: (selectedVariant: ProductColour[]) => void
  name: string
}

export type ProductColour =
  | 'white'
  | 'black'
  | 'silver'
  | 'stainless_steel'
  | 'cream'
  | 'red'
  | 'grey'
  | 'blue'
  | 'green'
  | 'clear'
  | 'copper'
  | 'chrome'
  | 'pink'
  | 'yellow'
  | 'beige'
  | 'orange'
  | 'purple'
  | 'brown'
  | 'gold'
  | 'rose_gold'
